import { AnimatedPresenceList } from '@affine/core/components/animated-presence-list';
import type { ReactNode } from 'react';

import { SIDEBAR_ATOM_STEP } from '../../../../modules/app-sidebar/views/sidebar-layout';

export const AnimatedNavigationPanelTreeChildren = ({
  children,
}: {
  children?: ReactNode;
}) => {
  return (
    <AnimatedPresenceList
      defaultHeight={SIDEBAR_ATOM_STEP}
      itemDataAttribute="data-navigation-panel-tree-presence-item"
    >
      {children}
    </AnimatedPresenceList>
  );
};
